import {
  QuarterCloseChecklistVendorEstimateQuery,
  QuarterCloseChecklistVendorEstimateSummary,
} from '../models/quarter-close-checklist.model';

export function filterVendorEstimates(
  vendorEstimateQuery: QuarterCloseChecklistVendorEstimateQuery
): QuarterCloseChecklistVendorEstimateSummary[] {
  if (
    !vendorEstimateQuery.success ||
    vendorEstimateQuery.errors.length ||
    !vendorEstimateQuery.data
  ) {
    return [];
  }

  return vendorEstimateQuery.data.map((vendorEstimateSummary) => {
    return {
      activitiesExceedingAmountRemaining:
        vendorEstimateSummary.activities_exceeding_amount_remaining,
      activitiesExceedingForecast: vendorEstimateSummary.activities_exceeding_forecast,
      id: vendorEstimateSummary.organization_id,
      name: vendorEstimateSummary.organization_name,
      vendorEstimateExists: vendorEstimateSummary.vendor_estimate_exists,
    };
  });
}
